module.exports = __webpack_public_path__ + "static/media/5.cecb56d1.png";